/**
 * Aplica o cupom de upgrade no carrinho quando houver solitário/aparador de upgrade.
 */
(function () {
  if (window.__andradeUpgradeDiscountBound) return;
  window.__andradeUpgradeDiscountBound = true;

  var CODE = window.AndradeUpgradeDiscountCode || 'up4T8B893VXB5FBG496gr0Na2FTde5K';
  var applying = false;

  function cartHasUpgrade(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i += 1) {
      var props = cart.items[i].properties || {};
      var origin = String(props['Origem'] || props['Origin'] || '');
      if (/upgrade/i.test(origin)) return true;
    }
    return false;
  }

  function applyCode() {
    if (applying) return;
    applying = true;
    var apply =
      window.AndradePdpLineItem && window.AndradePdpLineItem.applyUpgradeDiscountCode;
    var done = function () {
      applying = false;
    };
    if (typeof apply === 'function') {
      apply(document.querySelector('[data-md-pdp]')).then(done).catch(done);
      return;
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cartHasUpgrade(cart)) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: CODE }),
        });
      })
      .then(done)
      .catch(done);
  }

  document.addEventListener('cart:add', applyCode);
})();
